var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusiness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 461.862,
    height: 400
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1124",
    transform: "translate(-410.869 -367.114)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 1171",
    cx: 225.425,
    cy: 13.083,
    rx: 225.425,
    ry: 13.083,
    transform: "translate(410.869 740.947)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1122"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M589.277 609.779c1.084.808 40.582-3.836 40.582-3.836l11.339-41.344a5.24 5.24 0 00-5.252-6.626l-45.028 1.7a5.24 5.24 0 00-4.878 3.936l-9.847 38.426-20.142 3.908 33.226 3.836",
    fill: "#a7deff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M625.567 601.539h-44.193l8.729-36.693 45.422-1-9.958 37.7",
    fill: "#fffffe"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M657.726 625.527l-1.41 122.512 20.589.286a9.991 9.991 0 019.043 6.432h-66.8a10.028 10.028 0 019.547-7.1l18.678.259 1.408-122.389h-48.979a11.613 11.613 0 01-11.612-11.614h128.717a11.614 11.614 0 01-11.614 11.614z",
    fill: "#131412"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M571.613 617.114h161.868v-11.251H571.613z",
    fill: "#1a72f1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M684.344 597.797a3.649 3.649 0 01-3.644 3.645h-.041V591.33h.041a3.649 3.649 0 013.644 3.645zm-3.648-9.468h-.041v-2.164h-16.8v18.755a1.688 1.688 0 001.687 1.688h13.427a1.688 1.688 0 001.687-1.688v-.477h.041a6.654 6.654 0 006.646-6.646v-2.822a6.654 6.654 0 00-6.647-6.646z",
    fill: "#ff7381"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Combined-Shape",
    d: "M477.8 738.48a40.527 40.527 0 017.522.22c2.357.372 5.179 1.569 5.837 3.505 3.934 1.179 11.568 3.057 12.761 5.435 1.122 2.236.114 5.453-2.252 6.268a3.691 3.691 0 11-1.378-7.151l-9.354-2.3c-.894 1.6-3.257 2.264-5.26 2.577a128.155 128.155 0 01-13.762 1.513l-.821 2.826a2.643 2.643 0 013.124-.51 3.677 3.677 0 011.8 4.277c-1.523 4.709-7.155 2.021-7.716-1.639a27.72 27.72 0 01.757-4.869 68.236 68.236 0 01-6.066-.185c-1.767-.135-3.687-.244-5.086-1.288a3.407 3.407 0 01-1.572-2.106l-6.927 1.7a3.691 3.691 0 11-1.378 7.151c-2.366-.815-3.373-4.032-2.252-6.268 1.242-2.475 9.462-4.409 13.224-5.576a17.994 17.994 0 011.839-.757l.034-.065a.15.15 0 01-.033.065 54.511 54.511 0 0111.141-2.341v-57.148a2.908 2.908 0 015.815 0z",
    fill: "#131412"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M516.242 663.313s-8.214 22.43-53.214 17.9-21.052-23.917-4.918-23.917 58.133 6.02 58.133 6.02",
    fill: "#19243c"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M539.399 527.602s-1.378-10.469 0-10.469 2.479 5.234 2.479 5.234 5.373-10.193 6.061-9.918-3.03 9.642-3.03 9.642 5.234-9.229 5.923-9.091-3.719 10.331-3.719 10.331 4.683-7.714 5.234-7.576-3.307 8.4-3.307 8.4 4.685-5.51 5.235-5.372-1.24 4.683-10.745 14.05l-4.131-5.234",
    fill: "#fd9f9d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M542.097 522.131l4.133 3.857-.441.473-4.133-3.857.441-.473",
    fill: "#ff7381"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M513.335 544.866l26.169-17.446 4.846 6.138-23.257 26.815-7.754-15.507",
    fill: "#1a72f1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M547.257 730.958l-6.784 16.477 18.738-3.231-7.754-5.008 5.492-10.823-9.692 2.585M513.422 729.084l-7.212 18.173 17.392-2.307-6.43-4.327 6.43-11.539h-10.18",
    fill: "#0657cd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M532.172 660.162l-21.924 71.807 13.353-1.31 37.706-76.6-29.135 6.1",
    fill: "#ff516c"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M432.244 635.003s2.908 43.615 48.784 38.768 84.644-12.275 84.644-12.275l-22.615 72.691 15.507-3.554s45.23-80.49 28.43-93.713-72.368-7.408-72.368-7.408l-82.383 5.492",
    fill: "#ff7381"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M473.597 459.359s4.092.861 4.738 6.677a59.643 59.643 0 002.716 11.631l-2.714 2.154s2.155 7.754-1.939 9.046l-2.8 1.076v5.169l-15.488 2.154.841-9.692 3.877-22.615 10.769-5.6",
    fill: "#fd9f9d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M458.951 487.574s-3.015-25.63 2.369-27.565 11.2-3.93 11.2-3.93 2.369-5.77 6.246-5.119 3.014 9.692-4.093 11.631-5.093 13.568-5.093 13.568-3.091-4.092-4.6-1.292 2.371 4.954 3.662 5.6v4.742l-9.692 2.369M478.335 479.821a7.836 7.836 0 00-5.815 6.355s8.508-1.184 5.815-6.354",
    fill: "#19243c"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M475.428 472.07a1.185 1.185 0 10-1.184 1.184 1.184 1.184 0 001.184-1.184M471.971 470.173a.478.478 0 01-.333-.134.484.484 0 01-.017-.685 4.118 4.118 0 014.418-.967.485.485 0 01-.36.9 3.169 3.169 0 00-3.356.735.481.481 0 01-.351.151",
    fill: "#131412"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M469.372 479.416a.325.325 0 01-.227-.092l-3.207-3.15a.323.323 0 11.452-.461l3.212 3.149a.323.323 0 01-.226.554",
    fill: "#ff7381"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M435.152 523.22s3.553-29.331 34.22-29.331c38.789 0 54.3 76.176 69.808 95.237l40.061-6.461 3.231 10.015s-58.8 31.661-73.66 6.138l5.815 30.692s-67.845 11.954-82.383 5.492c0 0-2.261-87.229 2.908-111.782",
    fill: "#0657cd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M508.812 598.818l-16.8-28.107 18.924 39.318-2.124-11.211",
    fill: "#1a72f1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M565.672 661.494l10.661-1.938-12.4 7.515 1.735-5.577",
    fill: "#ff516c"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M579.241 582.665l9.046-1.615 9.046 3.231v2.908h-9.046l-6.56 3.182-2.486-7.705",
    fill: "#fd9f9d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M436.136 672.36c-19.532-22.571-11.338-72.366-10.99-74.467a2.262 2.262 0 014.462.74c-.082.494-7.848 49.536 9.981 70.806 8.054 9.609 23.869 11.782 23.869 11.782a26.713 26.713 0 01-27.323-8.862",
    fill: "#131412"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M453.563 575.065c-5.043-2.459-10.956-1.816-16.567-1.863a63.181 63.181 0 01-12.947-1.454c-2.185-.477-4.539-1.058-6.586-.156-2.83 1.247-3.811 4.709-4.342 7.756-.976 5.6-1.559 11.371-.5 16.958 4.343 22.859 41.842 18.754 48.574-.316 2.729-7.657-.329-17.362-7.635-20.925",
    fill: "#19243c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M557.436 367.114h209.35c5.71 0 10.338 4.152 10.338 9.274v147.226c0 5.122-4.628 9.274-10.338 9.274h-209.35c-5.709 0-10.338-4.152-10.338-9.274V376.388c0-5.122 4.629-9.274 10.338-9.274z",
    fill: "#303030",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Combined-Shape",
    d: "M567.608 502.415a1.615 1.615 0 110-3.231h44.363a1.615 1.615 0 110 3.231zm1.4 10.093a1.615 1.615 0 110-3.231h48.1a1.615 1.615 0 110 3.231zm0 10.123a1.615 1.615 0 010-3.231h32.629a1.615 1.615 0 010 3.231zm93.759-20.246a1.615 1.615 0 110-3.231h44.362a1.615 1.615 0 110 3.231zm0 10.122a1.615 1.615 0 110-3.231h35.52a1.615 1.615 0 010 3.231zm0 10.123a1.615 1.615 0 010-3.231h48.1a1.615 1.615 0 010 3.231z",
    fill: "#a7deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Combined-Shape",
    d: "M746.885 381.439a14.368 14.368 0 1011.819 24.385l-11.819-9.323zm13.822 21.85a14.363 14.363 0 00-10.595-21.85v13.495zM748.5 413.316a17.6 17.6 0 1117.6-17.6 17.619 17.619 0 01-17.6 17.6z",
    fill: "#00cd74",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 1081",
    d: "M724.079 487.249H565.993v-97.15h3.23v74l40.038-40.033v28.877l62.992-62.994v38.872h26.74v3.235h-29.969v-34.307l-62.994 62.992v-28.877l-36.307 36.306-.5-.5v16.351h154.856v3.228z",
    fill: "#ff7381"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M772.112 489.679l1.507-11.738-3.918 9.338 2.41 2.4",
    fill: "#009b56",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M815.734 502.525l-1.5-.375a4.113 4.113 0 01-3.119-4.083c.112-4.862.555-14.09 2.279-20.626 2.444-9.259-5.015-10.031-7.587-10.479s-8.617 8.807-9.26 9.579 1.029 2.058 1.029 2.058-.9 3.472-1.672 5.915 3.987 4.63 3.987 4.63l-.432 5.492c-.2 2.572-3.1 4.161-6.365 3.142-7.517 13.251 17.427 26.217 22.638 4.747",
    fill: "#fd9f9d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M815.969 501.678c-2.878 8.275-13.449 12.952-20.437 5.964-2.881-2.4-2.855-6.048-2.437-9.864-.29-.017-2.562-.525-2.562-.525s-6.942 13.583 10 19.137 22.079-13.052 22.079-13.052l-6.639-1.66",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M812.699 742.224l1.252 8.964-8.571 5.97h18.568l-.473-14.748c-3.592.058-7.183-.03-10.776-.186",
    fill: "#00cd74"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M823.476 742.405l-1.479-46.133 9.172-53.576h-23.882l-1.5 37.125a111.247 111.247 0 00.979 19.894l5.936 42.5c3.593.156 7.184.244 10.776.186",
    fill: "#fd9f9d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M785.169 741.124l1.4 10.059-8.571 5.97h18.568l-.507-15.819c-3.632-.163-7.262-.261-10.894-.21",
    fill: "#00cd74"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M803.791 642.695h-23.882l-1.552 38.35a97.579 97.579 0 00.859 17.455l5.953 42.623c3.632-.051 7.262.048 10.895.21l-1.446-45.062 9.173-53.576M776.093 488.759s-41.19-34.618-57.3-57.389l-5.92-10.553-3.372 1.862 3.186 11.1-4.181-1.51-1.364 1.03 7.381 5.137s25.47 41.535 54.906 67.311l6.665-16.988",
    fill: "#fd9f9d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M802.261 651.627l1.529-8.93h-23.882l-.361 8.93h22.714M829.64 651.627l1.529-8.93h-23.881l-.362 8.93h22.714",
    fill: "#ffaaa0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M776.094 488.759l-6.665 16.988 3.555 3.54c2.432-6.053 4.584-12.214 6.592-18.48l-3.482-2.048",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M832.743 538.744l8.886-1.944c.278-33.462-22.845-34.418-22.845-34.418-4.589 20.111-33.091 14.9-28.251-5.129l-10.958-6.446c-2.008 6.267-4.16 12.427-6.592 18.48l8.664 8.63c-1.389 10.552-11.108 131.071-11.108 131.071h72.756c1.111-11.941-10.552-110.245-10.552-110.245",
    fill: "#00cd74"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M819.849 639.239l43.107-9.685 6.26 30.022-41.024 11.521-8.346-31.858",
    fill: "#1a72f1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M821.913 640.103l42.21-13.052 8.609 29.436-39.988 14.718-10.83-31.1",
    fill: "#a7deff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Combined-Shape",
    d: "M842.3 664.636l-6.392-23.077 1.267-.543 6.391 23.077zm5.472-1.919l-6.392-23.077 1.267-.542 6.391 23.077zm5.472-1.919l-6.392-23.077 1.267-.543 6.391 23.077zm5.472-1.919l-6.391-23.077 1.267-.543 6.392 23.077zm5.472-1.919l-6.391-23.076 1.267-.542 6.391 23.076z",
    fill: "#1a72f1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M841.629 536.8l5.867 36.654a107.042 107.042 0 011.909 21.662c-.131 9.523-1.787 29.174-1.381 36.152l-1.751 10.5-3.913 1.111v-8.84l-3.643.833 2.08-6.711-2.758-42.487-9.044-46.375 12.635-2.5",
    fill: "#fd9f9d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M828.994 539.297l-.6-4.258 13.046-2.274.468 4.449-12.914 2.083",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M824.649 486.258c-.992-1.751-3.006-2.732-4.015-4.474-1.855-3.2.388-7.443-.9-10.913-.722-1.941-2.432-3.315-4.065-4.587-2.329-1.815-5.159-3.738-8-2.921a4.878 4.878 0 00-3.263 5.648c.621 2.517 3.175 4.135 4.05 6.576a5.479 5.479 0 01-.387 4.436 1.715 1.715 0 012.038-.262 2.2 2.2 0 01.843 2.453 3.355 3.355 0 01-1.828 1.994 7.339 7.339 0 01-2.705.6 9.911 9.911 0 1018.8 5.715 6.478 6.478 0 00-.57-4.258",
    fill: "#ff7381"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M807.385 485.665a1.55 1.55 0 10-1.55 1.55 1.55 1.55 0 001.55-1.55",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M803.493 474.612a.9.9 0 10-.9.9.9.9 0 00.9-.9M805.108 473.887a.417.417 0 01-.4-.313 2.056 2.056 0 00-2.191-1.45.417.417 0 01-.124-.824 2.9 2.9 0 013.122 2.066.416.416 0 01-.3.507.392.392 0 01-.1.013",
    fill: "#131412"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M806.815 483.037a.273.273 0 01-.191-.076.277.277 0 01-.011-.392 6.2 6.2 0 012.92-1.724.278.278 0 01.139.538 5.642 5.642 0 00-2.656 1.567.276.276 0 01-.2.087M799.891 489.145l3.343 1.415-3.485.385.141-1.8",
    fill: "#ff7381"
  }))))));
}
export default SvgBusiness;